import React from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { Icon } from "@ddm-design-system/icon";
import { TertiaryButton } from "@ddm-design-system/button";
import { useIsMobile } from "@ddm-design-system/hooks";
import Routes from "../../../routes";
import useContent from "../../../hooks/useContent";
import { getFeedbackFormUrl } from "../../../helpers";
import "./footer.scss";
import { getCurrentLanguage } from "../../../store/content/selectors";

export interface IProps {}

export const Footer: React.FC<RouteComponentProps & IProps> = ({ history }) => {
  const isMobile = useIsMobile();
  const locale = useSelector(getCurrentLanguage);

  const { managerAppCommon: content } = useContent();

  if (
    history.location.pathname === Routes.login ||
    history.location.pathname === Routes.firstLogin
  ) {
    return <></>;
  }

  const Feedback = () => (
    <a
      className="footer-feedback-anchor"
      href={getFeedbackFormUrl(locale)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <TertiaryButton icon="Feedback" className="footer-feedback-text">
        {content.manager_app_footer_feedback_link}
      </TertiaryButton>
    </a>
  );

  return !isMobile ? (
    <div className="footer">
      <div className="footer-content">
        <div className="footer-content-item">
          <Icon name="DmFullLogo" height={32} />
        </div>

        <div className="footer-content-item">
          <Feedback />
        </div>
      </div>
    </div>
  ) : (
    <div className="footer">
      <Feedback />
    </div>
  );
};

export default withRouter(Footer);
